<template>
  <div>
    <el-upload
      :action="uploadUrl"
      :headers="{'Authorization': token}"
      :multiple="multiple"
      :limit="limitImgNum"
      :on-success="uploadImgBtn">
      <div class="color-theme">{{warmTxt}}</div>
    </el-upload>
  </div>
</template>

<script>

export default {
  name: "UploadFile",
  props: {
    multiple: {
      type: Boolean,
      default:false
    },
    // 上传后显示图片
    fileList: {
      type: Array,
      default:[]
    },
    // 限制上传图片的张数
    limitImgNum: {
      type: Number,
      default: 1
    },
    /* 上传文件大小限制(MB) */
    fileSize: {
      type: Number,
      default: 5,
    },
    /* 多个的话，判断是哪个需要的 */
    imgWhich: {
      type: Number,
      default: 1
    },
    warmTxt: {
      type: String,
      default: '若需要更换图片，请先删除原图片'
    }
  },
  watch: {
    fileList: {
      handler(val) {
        if (val) {
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.fileList.split(',');
          // 然后将数组转为对象数组
          this.fileCurrentList = list.map(item => {
            if (typeof item === "string") {
              if (item.indexOf(this.baseUrl) === -1 && !isExternal(item)) {
                  item = { name: this.baseUrl + item, url: this.baseUrl + item };
              } else {
                  item = { name: item, url: item };
              }
            }
            return item;
          });
        } else {
          this.fileCurrentList = [];
          return [];
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      baseUrl: this.$baseUrl,
      token:sessionStorage.getItem('token'),
      uploadUrl: this.$baseUrl + "/selenium/journey/config/uploadWxPayCertificate", // 上传的图片服务器地址
      fileCurrentList:[],
      imgUrl:''
    };
  },
  mounted() {

  },
  methods: {
    uploadImgBtn (file) {
      var backData = {
        imgUrl:file.data.fileUrl,
        imgWhich:this.imgWhich
      }
      this.$emit("imgUrlBtn", backData);
    },
    /* 删除上传的图片 */
    delImgBtn(file,fileList){
      var imgUrl = '';
      fileList.forEach(function(item){
        imgUrl = item.url;
      });
      var backData = {
        imgUrl:imgUrl,
        imgWhich:this.imgWhich
      }
      this.$emit("imgUrlBtn", backData);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UploadFile.vue